// extracted by css-extract-rspack-plugin
export default {"emailKindCellRoot":"EmailKindCell_emailKindCellRoot__qTWj0","label":"EmailKindCell_label__CmA-3","icon":"EmailKindCell_icon__rZJQR"};